<h2 mat-dialog-title>Just one more step</h2>
<mat-dialog-content class="mat-typography">
  <div class="main">
    <h3>Your Renting period starts:</h3>
    <h4>{{data.dressData.start_date | date: 'shortDate'}}</h4>
    <h3>Your Renting period ends:</h3>
    <h4>{{data.dressData.end_date  | date: 'shortDate'}}</h4>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="checkout" (click)="order()">Rent it</button>
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>